import React from 'react';
import { unreachable } from '../../../../ts-utils';
import { ReactionConfigContext } from './reaction-config-context';
export const ReactionConfigProvider = (props) => {
    const value = props.config.type === 'likes' ? mapExternalToInternalLikes(props.config) : props.config;
    return (React.createElement(ReactionConfigContext.Provider, { value: value }, props.children));
};
const DEFAULT_MAIN_EMOTION = 'heart';
const mapExternalToInternalLikes = (config) => {
    return {
        type: config.type,
        mainEmotion: (() => {
            switch (config.icon) {
                case 'love':
                case 'heart':
                    return 'heart';
                case 'thumbs_up':
                case 'thumbsup':
                    return 'thumbsup';
                case undefined:
                    return DEFAULT_MAIN_EMOTION;
                default:
                    unreachable(config.icon);
                    return DEFAULT_MAIN_EMOTION;
            }
        })(),
    };
};
export default ReactionConfigProvider;
//# sourceMappingURL=reaction-config-provider.js.map